var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCheck140 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 140,
  height: 140,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M127.303 18.602a.5.5 0 0 1 .095.7l-76 100.001a.5.5 0 0 1-.752.051l-36-36a.5.5 0 0 1 .708-.707l35.595 35.594 75.653-99.543a.5.5 0 0 1 .701-.096Z",
  clipRule: "evenodd"
})));
export { SvgCheck140 as ReactComponent };
export default __webpack_public_path__ + "d19aa445dd417afda7e456d71ac4d549.svg";